// Global Values
var productPrice, comparePrice, salePriceSum, valueMultiplier,
    bundleLoop = bundleCalc(), bundleLoopValue, unformattedPPD, PPD,
    initBuyBox = false, newVal;

// Will determine the ppd of the bundle product pages
function determinePPD() {  
  let product_ppd = $(".price-per-day"),
      total_price,
      valueMultiplier,
      ppd;

  // If a bundle product page, then calculate price-per-day and then return it.
    total_price = $("#ComparePrice").text().replace(/[^0-9\.-]+/g,"");
    valueMultiplier = $(".bundle-product-form .qty__adjust--plus").siblings('input').val();
    ppd = (total_price / (60 * valueMultiplier));
      
    // Set the ppd attribute to the price of the products.
    product_ppd.attr("ppd", "$"+ppd.toFixed(2));
    
    return ppd; // Return normal product bundle version of ppd.
}


// Grab the number of items in the bundle pages
function bundleCalc() {
  let products = $('.bundle-price__product'),
      numOfItems = 0;

  products.each(function() {
    numOfItems = numOfItems + ($(this).data("quantity"));
  });

  return numOfItems;
}

// Bundle Variant Select Functionality
$('.product-variant-selector').each(function(i){
    function updateBundleVariantImage(vid) {
      $(`.product-list-item--${i+1} .prod-block-img__variant.variant-${vid}`).removeClass('variant-hide');
      $(`.product-list-item--${i+1} .prod-block-variant-price .variant__price.variant-${vid}`).removeClass('variant-hide')
    }

    $(this).on('change', function(){
      let var_id = $(this).find('option:selected').data('variant-id');
      $(`.product-list-item--${i+1} .prod-block-img__variant`).addClass('variant-hide');
      $(`.product-list-item--${i+1} .prod-block-variant-price .variant__price`).addClass('variant-hide');
      updateBundleVariantImage(var_id);
    });

    updateBundleVariantImage($(this).find('option:selected').data('variant-id'));
})

// Will prevent users from leaving a "0" in the quantity selector. And return the value of the quantity selector.
function verifyQty() {
  let q = $('.quantity_selector #Quantity');
  (q.val() == "0") ? (q.val(1)) : '';
  return q.val();
}

// If the user or customer reaches below '2' on the quantity selector, then the minus button will be disabled.
function determineQty(qty) {
  let qtyMinusBtn =  $('.quantity_selector .qty__adjust--minus');
  if(qty < 2) {
    qtyMinusBtn.attr('disabled', 'disabled');
    qtyMinusBtn.addClass('js-qty__disable');
  } else {
    qtyMinusBtn.removeAttr('disabled');
    qtyMinusBtn.removeClass('js-qty__disable');
  }
}

// Will grab the buy box values and generate the compare and product prices
function updatePrices() {
  productPrice = $('.buy-block__price-wrap #ComparePrice').attr('content');
  comparePrice = $('.buy-block__price-wrap #ProductPrice2').attr('content');
  valueMultiplier = $('.quantity_selector #Quantity').val();

  salePriceSum = 0;
  bundleLoop = bundleCalc();
  bundleLoopValue = bundleLoop * valueMultiplier;
  unformattedPPD = $('.price-per-day').data('price-per-day');
  
  productPrice = Number(productPrice.replace(/[^0-9\.-]+/g,""));
  comparePrice = Number(comparePrice.replace(/[^0-9\.-]+/g,""));
  
  // Will determine if the product is a single sale product
  $('.bundle-price__product').each(function(){
    salePriceSum += (parseFloat(($(this).attr('data-original-price'))));
  });
  
  prod_vars = $("#ComparePrice").text();
  prod_price = prod_vars;

  // If the buy box is initialized, then apply the value multiplier to the compare and sales prices
  if(initBuyBox === true) {
    comparePrice = comparePrice * valueMultiplier;
    productPrice = productPrice * valueMultiplier;
    salePriceSum = salePriceSum * valueMultiplier;
  }

  // Will determine if the sale price has a lower number at its third decimal place
  if(salePriceSum) {
    let sps = salePriceSum,
        sps_arr = sps.toFixed(3).toString("").split(""),
        sps_last_decimal = parseInt(sps_arr[sps_arr.length - 1]);
    
    if(sps_last_decimal <= 5) {
      $('#ComparePrice').text('$' + (Math.floor(salePriceSum * 100) / 100));
    } else {
      $('#ComparePrice').text('$' + ((Math.round((salePriceSum + Number.EPSILON) * 100) / 100).toFixed(2)));
    }

    // Also update the content attribute for structured data
    $('#ComparePrice').attr('content', salePriceSum.toFixed(2));
  }

  // ✅ Updated Compare Price: set both text and content
  let updatedComparePrice = (Number(productPrice) + 5.03).toFixed(2);
  $('#ProductPrice2').text(`$${updatedComparePrice}`);
  $('#ProductPrice2').attr('content', updatedComparePrice);

  // Update per-day price
  $('.price-per-day').text(`That's only \n $${(determinePPD().toFixed(2))} per day!`);
}

// Bug fixes on the bundle pages
function bundleBugFixes() {
  $(document).ready(()=>{
    // Removes "aria-hidden" from all the product images on the magnesium bungle page.
    $(".showcase .slick-slide").removeAttr("aria-hidden");

    // Adds the color black the dynamic savings.
    $('.dynamic-savings-total').addClass('text--black');
  })
}

$('.bundle-product-form .quantity_selector').click(function(){
  determineQty(verifyQty());
})

function bundleBuyBoxListeners() {
  if ($('#buy-now').length) {
    // Handle quantity changes and price updates on bundle page
    $(document).ready(function(){
      $(".bundle-product-form .quantity_selector").on('input',(e) => { $(this).attr('value',$(this).val()); });
      $(".bundle-product-form .qty__adjust--plus").on('click', () => { currentVal = parseInt($(this).siblings('input').attr('value')); if (!isNaN(currentVal)) { $(this).siblings('input').attr('value',currentVal + 1); }});
      $(".bundle-product-form .qty__adjust--minus").on('click',() => { currentVal = parseInt($(this).siblings('input').attr('value')); newVal = currentVal - 1; if(newVal < 1) { newVal = 1;} if (!isNaN(currentVal)) { $(this).siblings('input').attr('value',newVal);}});
      $(".bundle-product-form").on('click', "qty__adjust", () => { updatePrices(); });
      $(".bundle-product-form").change(() => { updatePrices(); });
      $(".bundle-product-form").on('propertychange input', ".quantity_selector", () => { updatePrices(); });
    });
  }

    $(function(){
    //IF SOMEONE CLICKS THE BUTTON WITH THE AFFORMENTIONED CLASS
    $('.bundle--add-to-cart').click(function(e){
      e.preventDefault();
  
      // Form selector
      var $formSelector = $('.bundle-product-form');
  
      // Product ID & Qty array
      var bundleProductIds = [];
      var bundleProductQty = [];
      $('.bundle-price__product').each(function(){
        bundleProductIds.push( $(this).attr('data-variant-id'));
        bundleProductQty.push( $(this).attr('data-quantity'));
      });
  
      //  Quantity Settings
      var bundleQuantitySelector = $('.bundle-product-form .js-quantity-selector').val();
  
      // create an array of selected products
      var dataToPass = [];
      // add objects to the array
      bundleProductIds.forEach((item, index) => {
        var productQuantity = bundleProductQty[index],
            addToCartQuantity = bundleQuantitySelector * productQuantity;
        dataToPass.push(new productArray(item, addToCartQuantity));
      });
  
      // Pull product ratings and review count to pass to cart object attributes
      var productRatingsName = [],
          productRatingsValue = [],
          productReviewCountName = [],
          productReviewCountValue = [];
      $('.product__rating').each(function(){
        productRatingsName.push( $(this).attr('name'));
        productRatingsValue.push( $(this).val());
      });
      $('.product__review').each(function(){
        productReviewCountName.push( $(this).attr('name'));
        productReviewCountValue.push( $(this).val());
      });
  
      // Object created
      var ratingObj = {},
          reviewObj = {};
  
      // Using loop to insert key
      // value in Object
      for(var i = 0; i < productRatingsName.length; i++){
        ratingObj[productRatingsName[i]] = productRatingsValue[i];
      }
      for(var i = 0; i < productReviewCountName.length; i++){
        reviewObj[productReviewCountName[i]] = productReviewCountValue[i];
      }
  
      var finalAttributes = Object.assign(ratingObj, reviewObj);
  
      //console.log(finalAttributes);
  
  
      //POST IT
      $.ajax({
        type: "POST",
        url: '/cart/add.js',
        dataType: 'jsonp',
        cors: true ,
        data: {
          items: dataToPass,
          attributes: finalAttributes,
        },
  
        //Open the sidecart after success
        complete: function () {
          addToCartOk();
        }
  
      });
    })
  })

    if ($('.bundle-buy-box').length) {
    $window = $(window);
    $window.scroll(function() {
      if (window.matchMedia('(max-width: 767px)').matches) {
        if ( $window.scrollTop() > 0) {
          $("#header").addClass("is-scrolled");
        }
        if ( $window.scrollTop() == 0) {
          $("#header").removeClass("is-scrolled");
        }
      }
      else {
        if ( $window.scrollTop() > 0) {
          $("#header").addClass("is-scrolled");
        }
        if ( $window.scrollTop() == 0) {
          $("#header").removeClass("is-scrolled");
        }
      }
    }); 
  }


  // If bundle contains variant products, show first thumbnail
  $('.bundle-products .bundle-product-form .buy-box__left img.variant-hide:first-of-type').show();

  // Add active class to selected variant if variant options are present for a product
  $('.bundle-products .bundle-product-form select').change(function(){
    $(this).find(':selected').addClass('bundle-price__product')
    .siblings('option').removeClass('bundle-price__product');
  
    //  Find slide to go to based off product selection in buy box
    var thumbnailSlideNumber = $(this).find(':selected').attr('data-slide-target');
  
    $('.product-page-buy-box-slider').slick('slickGoTo',thumbnailSlideNumber);
  
    // recalculate price in price box
    bundlePriceBoxFunction();
  
    var productTitle = $(this).attr('data-product-name');
    var bundleVariantId = $(this).find(':selected').attr('data-variant-id');
    $(this).closest('#product-' + productTitle).find('.variant-hide').hide();
    $('.variant-' + bundleVariantId).show();
  });

  // Single variant product thumbnail to trigger product thumbnail slider
  $('.bundle-product-thumbnail-anchor').on('click',function(){
    var thumbnailSlideNumber = $(this).attr('data-slide-target');
  
    $('.product-page-buy-box-slider').slick('slickGoTo',thumbnailSlideNumber);
  
  });
}

// Determine if the user is a B2B customer
function isB2B() {
  let condition;
  $('.b2b-customer').length != 0 ? condition = true : condition = false;
  return condition;
}

function initBundleBuyBox() {
  // Will check if the buy box was initialized
  bundleBuyBoxListeners();

  // B2B Customer Logic
  if(isB2B()){
    $('.price-container #ComparePrice').hide();
  }
}

/*** Bundle Product Hero / Gallery Functionality ***/
/**
 * 'pid' -> 'Product ID'
 */
// Grab Variant ID
function getVID(e) {
  const variantClass = Array.from(e.classList).find(cls => cls.startsWith('variant-'));
  if (variantClass) {
    const vid = variantClass.split('variant-')[1];
    return vid;
  }
  return null; // Or throw an error if preferred
}

// Grab Product ID
function getPID(e) {
  const productClass = Array.from(e.classList).find(cls => cls.startsWith('product-'));
  if (productClass) {
    const pid = productClass.split('product-')[1];
    return pid;
  } else if(e.data('product-id')) {
    const pid = e.data('product-id');
    return pid;
  }
  return null; // Or throw an error if preferred
}

// Hide Variant Content
/*function hideAllVariantContent() {
  const elements = document.querySelectorAll('[class*="vid--"]');
  elements.classList.add('variant-hide');
}

function showVariantContent(id) {
  elements.classList.remove('variant-hide');
}

function hideAllProductContent() {
  const elements = document.querySelectorAll('[class*="pid--"]');
  elements.classList.add('product-hide');
}

function showVariantContent(id) {
  elements.classList.remove('product-hide');
}

$('#product_selector #product_list li').click(function(){
  let pid = $(this).data('product-id');
  hideAllProductContent();
  showProductContent(getPID(pid));
  console.log("PID: ", pid);
})*/

initBundleBuyBox();
